import FormRepeaterItem from './FormRepeaterItem'

export default {
  name: 'UiFormRepeater',

  components: { FormRepeaterItem },

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  // language=HTML (for PhpStorm)
  template: `
    <div class="form-repeater">
      <div class="form-repeater__items">
        <slot name="items">
          <vue-draggable
            v-model="wrappedItems"
            :disabled="!sortable"
            handle=".form-repeater-item__sort-handle"
          >
            <div v-for="wrap in wrappedItems" :key="wrap.item.id">
              <FormRepeaterItem
                v-model="wrap.item"
                :confirm-delete="confirmDelete"
                :inline-fields="inlineFields"
                :sortable="sortable"
                @remove="removeItem">
                <template #default="{ item }">
                  <slot name="item" :item="item"></slot>
                </template>
              </FormRepeaterItem>
            </div>
          </vue-draggable>
        </slot>
      </div>
      <div class="form-repeater__actions" v-if="canAddItem">
        <button
          type="button"
          class="button"
          @click="addItem"
        >
          <slot name="add-item-text">Add Item</slot>
        </button>
      </div>
    </div>
  `,

  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    newItemFn: {
      type: Function,
      required: true,
    },
    confirmDelete: {
      type: Boolean,
      default: true,
    },
    inlineFields: {
      type: Boolean,
      default: false,
    },
    sortable: {
      type: Boolean,
      default: false,
    },
    maxItems: {
      type: Number,
      default: -1,
    },
  },

  computed: {
    // Workaround for Vue.Draggable 2.x.
    wrappedItems: {
      get() {
        return this.modelValue.map(i => ({ item: i }))
      },
      set(items) {
        this.$emit('update:modelValue', items.map(i => i.item))
      },
    },

    canAddItem() {
      return this.maxItems === -1 || this.modelValue.length < this.maxItems
    },
  },

  watch: {
    modelValue: {
      deep: true,
      handler() {
        this.$emit('update:modelValue', this.modelValue)
      },
    },
  },

  methods: {
    addItem() {
      this.modelValue.push(this.newItemFn())
    },

    removeItem(item) {
      const idx = this.modelValue.findIndex(i => i === item)
      if (idx !== -1) {
        this.modelValue.splice(idx, 1)
      }
    },
  },
}
